import Wix from './wix-sdk-polyfill';

export default class TpaInstallListener {
  appDefinitionIds;
  interval;
  onInstallCallbacks = [];
  onDeleteCallbacks = [];
  listenInterval;
  status = {};

  constructor(appDefinitionIds = [], interval = 5000) {
    this.appDefinitionIds = appDefinitionIds;
    this.interval = interval;
    this.appDefinitionIds.forEach(appDefinitionId =>
      Wix.isApplicationInstalled(appDefinitionId, isInstalled => {
        this.status[appDefinitionId] = isInstalled;
      }),
    );
  }

  onInstall(cb) {
    this.onInstallCallbacks.push(cb);
  }

  onDelete(cb) {
    this.onDeleteCallbacks.push(cb);
  }

  listen() {
    this.listenInterval = setInterval(() => {
      this.appDefinitionIds.forEach(appDefinitionId =>
        Wix.isApplicationInstalled(appDefinitionId, isInstalled => {
          if (this.status[appDefinitionId] !== isInstalled) {
            if (isInstalled) {
              Wix.getInstalledInstance(appDefinitionId, ({ instanceId }) => {
                this.onInstallCallbacks.forEach(cb => setTimeout(() => cb(appDefinitionId, instanceId)));
              });
            } else {
              this.onDeleteCallbacks.forEach(cb => setTimeout(() => cb(appDefinitionId)));
            }
          }
          this.status[appDefinitionId] = isInstalled;
        }),
      );
    }, this.interval);
  }

  stop() {
    clearInterval(this.listenInterval);
  }
}
